import React, { useState } from "react";
import { Box, Grid, Typography, IconButton, Dialog, DialogContent } from "@mui/material";
import { IoMdAdd } from "react-icons/io";
import { ChevronLeft, ChevronRight, Close } from "@mui/icons-material";

const ReservationsCard = ({
  reservationNumber,
  dateOfReservation,
  firstName,
  lastName,
  email,
  customerPhone,
  customerAddress,
  customerStreet,
  customerPLZ,
  customerCity,
  paymentDate,
  payWay,
  status,
  note,
  adminNote,
  numberOfPersons,
  onClick,
  extraObjectsList,
  totalPackagePrice,
  totalExtraObjectsPrice,
  totalPrice,
  name,
  images,
  isAGift,
  nameOfreceiver,
  emailOfreceiver,
  noteForReceiver
}) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imageDialogOpen, setImageDialogOpen] = useState(false);

  const nextImage = () => {
    if (images && images.length > 1) {
      setCurrentImageIndex((prev) => (prev + 1) % images.length);
    }
  };

  const prevImage = () => {
    if (images && images.length > 1) {
      setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
    }
  };

  const openImageDialog = () => {
    setImageDialogOpen(true);
  };

  const closeImageDialog = () => {
    setImageDialogOpen(false);
  };
  return (
    <Box>
      <Box sx={{
        mt: 3,
        bgcolor: "white",
        py: 6,
        px: 6,
        borderRadius: "8px",
      }}>
        <Grid container spacing={6}>
          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              fontFamily: "Noto Sans JP",
              color: "#CD9D41",
              fontSize: "20px",
            }}>
              Buchungsnummer:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {reservationNumber}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              fontFamily: "Noto Sans JP",
              color: "#CD9D41",
              fontSize: "20px",
            }}>
              Vorname:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {firstName}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Nachname:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {lastName}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Email:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {email}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Telefon:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {customerPhone || "Nicht angegeben"}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Straße und HausNr:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {customerStreet || "Nicht angegeben"}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              PLZ:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {customerPLZ || "Nicht angegeben"}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Stadt:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {customerCity || "Nicht angegeben"}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Reservierungsdatum:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {dateOfReservation}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Enddatum der Reservierung:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {paymentDate}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Zahlungsmethode:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {payWay}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Anzahl der Personen
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {numberOfPersons}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Paketname
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {name}
            </Typography>
          </Grid>

          <Grid display="flex" size={6} gap={1} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Extra:
            </Typography>
            <Box>
              {extraObjectsList?.map((item, index) => (
                <Typography key={index} sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
                    Name: {item.name}, Anzahl der Extras: {item.number}, Price: {item.price}€
                </Typography>
              ))}
            </Box>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Gesamtpaketpreis:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {totalPackagePrice}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              
              Extrapreis:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {totalExtraObjectsPrice}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Gesamtpreis:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {totalPrice}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Status:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {status}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Notiz
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {note}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
             Admin Notiz:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px", flex: 1 }}>
              {adminNote || "Es gibt keine Notizen"}
            </Typography>
            <IconButton onClick={onClick}>
              <IoMdAdd color="#36D06A" style={{ zIndex: "100px" }} />
            </IconButton>
          </Grid>

          {/* Gift Information Section */}
          {isAGift && (
            <>
              <Grid size={12}>
                <Box sx={{
                  backgroundColor: "#fff0f5",
                  borderRadius: "12px",
                  p: 3,
                  border: "2px solid #ff69b4",
                  mt: 2
                }}>
                  <Typography sx={{
                    color: "#d63384",
                    fontFamily: "Noto Sans JP",
                    fontSize: "24px",
                    fontWeight: "bold",
                    mb: 3,
                    display: "flex",
                    alignItems: "center",
                    gap: 1
                  }}>
                    🎁 Geschenkinformationen
                  </Typography>
                  
                  <Grid container spacing={3}>
                    <Grid display="flex" gap={2} size={6} alignItems="center">
                      <Typography sx={{
                        color: "#d63384",
                        fontFamily: "Noto Sans JP",
                        fontSize: "18px",
                        fontWeight: "600"
                      }}>
                        Empfänger:
                      </Typography>
                      <Typography sx={{ 
                        fontFamily: "Noto Sans JP", 
                        fontSize: "16px",
                        fontWeight: "500"
                      }}>
                        {nameOfreceiver || "Nicht angegeben"}
                      </Typography>
                    </Grid>

                    <Grid display="flex" gap={2} size={6} alignItems="center">
                      <Typography sx={{
                        color: "#d63384",
                        fontFamily: "Noto Sans JP",
                        fontSize: "18px",
                        fontWeight: "600"
                      }}>
                        E-Mail des Empfängers:
                      </Typography>
                      <Typography sx={{ 
                        fontFamily: "Noto Sans JP", 
                        fontSize: "16px",
                        fontWeight: "500"
                      }}>
                        {emailOfreceiver || "Nicht angegeben"}
                      </Typography>
                    </Grid>

                    {noteForReceiver && (
                      <Grid size={12}>
                        <Typography sx={{
                          color: "#d63384",
                          fontFamily: "Noto Sans JP",
                          fontSize: "18px",
                          fontWeight: "600",
                          mb: 1
                        }}>
                          Persönliche Nachricht:
                        </Typography>
                        <Box sx={{
                          backgroundColor: "rgba(255, 105, 180, 0.1)",
                          padding: "12px",
                          borderRadius: "8px",
                          border: "1px dashed #ff69b4"
                        }}>
                          <Typography sx={{ 
                            fontFamily: "Noto Sans JP", 
                            fontSize: "16px",
                            fontStyle: "italic",
                            color: "#d63384"
                          }}>
                            "{noteForReceiver}"
                          </Typography>
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </Grid>
            </>
          )}

          {/* Images Section */}
          {images && images.length > 0 && (
            <Grid size={12}>
              <Typography sx={{
                color: "#CD9D41",
                fontFamily: "Noto Sans JP",
                fontSize: "20px",
                mb: 2
              }}>
                Gutschein Bilder ({images.length}):
              </Typography>
              <Box sx={{ 
                position: 'relative', 
                maxWidth: 400, 
                mx: 'auto',
                border: '2px solid #CD9D41',
                borderRadius: '8px',
                overflow: 'hidden'
              }}>
                <Box
                  component="img"
                  src={`${process.env.REACT_APP_API_URL}/${images[currentImageIndex]}`}
                  alt={`Gutschein ${currentImageIndex + 1}`}
                  sx={{
                    width: '100%',
                    height: 300,
                    objectFit: 'cover',
                    cursor: 'pointer'
                  }}
                  onClick={openImageDialog}
                />
                
                {images.length > 1 && (
                  <>
                    <IconButton
                      onClick={prevImage}
                      sx={{
                        position: 'absolute',
                        left: 8,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        bgcolor: 'rgba(0,0,0,0.5)',
                        color: 'white',
                        '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                      }}
                    >
                      <ChevronLeft />
                    </IconButton>
                    
                    <IconButton
                      onClick={nextImage}
                      sx={{
                        position: 'absolute',
                        right: 8,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        bgcolor: 'rgba(0,0,0,0.5)',
                        color: 'white',
                        '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                      }}
                    >
                      <ChevronRight />
                    </IconButton>
                    
                    <Box sx={{
                      position: 'absolute',
                      bottom: 8,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      bgcolor: 'rgba(0,0,0,0.7)',
                      color: 'white',
                      px: 2,
                      py: 0.5,
                      borderRadius: 1,
                      fontSize: '14px'
                    }}>
                      {currentImageIndex + 1} / {images.length}
                    </Box>
                  </>
                )}
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>

      {/* Full Screen Image Dialog */}
      <Dialog
        open={imageDialogOpen}
        onClose={closeImageDialog}
        maxWidth="lg"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            bgcolor: 'rgba(0,0,0,0.9)',
            boxShadow: 'none'
          }
        }}
      >
        <DialogContent sx={{ p: 0, position: 'relative' }}>
          <IconButton
            onClick={closeImageDialog}
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              color: 'white',
              bgcolor: 'rgba(0,0,0,0.5)',
              zIndex: 1000,
              '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
            }}
          >
            <Close />
          </IconButton>
          
          {images && images.length > 0 && (
            <Box sx={{ position: 'relative', textAlign: 'center' }}>
              <Box
                component="img"
                src={`${process.env.REACT_APP_API_URL}/${images[currentImageIndex]}`}
                alt={`Gutschein ${currentImageIndex + 1}`}
                sx={{
                  maxWidth: '100%',
                  maxHeight: '80vh',
                  objectFit: 'contain'
                }}
              />
              
              {images.length > 1 && (
                <>
                  <IconButton
                    onClick={prevImage}
                    sx={{
                      position: 'absolute',
                      left: 16,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      bgcolor: 'rgba(0,0,0,0.5)',
                      color: 'white',
                      '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                    }}
                  >
                    <ChevronLeft />
                  </IconButton>
                  
                  <IconButton
                    onClick={nextImage}
                    sx={{
                      position: 'absolute',
                      right: 16,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      bgcolor: 'rgba(0,0,0,0.5)',
                      color: 'white',
                      '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                    }}
                  >
                    <ChevronRight />
                  </IconButton>
                  
                  <Box sx={{
                    position: 'absolute',
                    bottom: 16,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    bgcolor: 'rgba(0,0,0,0.7)',
                    color: 'white',
                    px: 2,
                    py: 1,
                    borderRadius: 1,
                    fontSize: '16px'
                  }}>
                    {currentImageIndex + 1} / {images.length}
                  </Box>
                </>
              )}
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ReservationsCard;
